module.exports = __webpack_public_path__ + "static/media/costco-small.564fb205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/costco-small.png
// module id = 681
// module chunks = 27